import { useSelector } from "react-redux";
import { useCallback } from "react";
import userSessionData from "../services/userSessionData";

export const useCompanyData = () => {
  const companyData = useSelector((state) => state.user.company);
  const sessionId = useSelector((state) => state.authSession.sessionId);
  const refreshCompanyData = useCallback(
    (companyId) => userSessionData.loadCompany(companyId, sessionId),
    [sessionId],
  );
  return { companyData, refreshCompanyData };
};
